import template from "./import_file_view.html";
import controller from "./import_file_view.controller";
import "./import_file_view.scss";

let branchManagementImportFileViewComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementImportFileViewComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/import_file_view/import_file_view.component.js